import React from "react";
import { shallowEqual } from "react-redux";
import { formatPriceIntl } from "../../../../../../../common-deprecated/priceUtils";
import { removeAccessory, removePack } from "../../../../../redux/actions/UscBasketActions";
import { useUscDispatch, useUscSelector } from "../../../../../redux/store";
import {
    type UscAccessoryType,
    type UscPackType,
    getAccessoryPackPriceSelector,
} from "../../../../../utils/accessoryUtils";
import { useUscLabel } from "../../../../../utils/labels";
import Text from "../../../../../../shared-components/toyota/styles/atoms/Text";
import Icon from "../../../../../../shared-components/toyota/styles/atoms/Icon";
import Button from "../../../../../../shared-components/toyota/styles/atoms/Button";

type BasketAccessoryPackItemProps = {
    accessoryOrPack: UscAccessoryType | UscPackType;
};

const BasketAccessoryPackItem = ({ accessoryOrPack }: BasketAccessoryPackItemProps): JSX.Element => {
    const dispatch = useUscDispatch();
    const commonSettings = useUscSelector((state) => state.commonSettings);
    const accessoryPrice = useUscSelector(getAccessoryPackPriceSelector(accessoryOrPack), shallowEqual);
    const [loadingLabel, ariaRemoveAccessoryLabel] = useUscLabel(["uscLoading", "uscA11yButtonRemoveAccessory"]);

    const isPack = "items" in accessoryOrPack;

    const handleRemove = (): void => {
        if (isPack) dispatch(removePack(accessoryOrPack.id));
        else dispatch(removeAccessory(accessoryOrPack.id));
    };

    return (
        <li key={accessoryOrPack.id}>
            <Text variant="body-small-book">{accessoryOrPack.name}</Text>
            <span>
                <Text variant="body-small-book" color="grey-7">
                    {accessoryPrice && (
                        <>
                            {accessoryPrice.cashLoading
                                ? loadingLabel
                                : formatPriceIntl(commonSettings, accessoryPrice.cashPrice.cashPriceInclVat)
                                      .primaryPrice}
                        </>
                    )}
                </Text>
                <Button
                    variant="control-grey"
                    size="small"
                    aria-label={ariaRemoveAccessoryLabel}
                    onClick={handleRemove}
                >
                    <Icon variant="close" />
                </Button>
            </span>
        </li>
    );
};

export default BasketAccessoryPackItem;
